module.exports = __webpack_public_path__ + "img/Siemens_logo.6a2f2212.jpg";